/**
 * amaActivites Module
 */
 import Vue from 'vue';
 import { apiModel, makeApiRequest } from "../../../api";
 import _ from "lodash";
 // States
 const state = {
     amaActivites: [],
     activitesList: [],
     amaActivite: {},
     commandes_attentes: [],
    //  pecsList: [],
     pecActivites:{},
 };
 
 // Getters
 const getters = {
    amaActivites: state => {
         return state.amaActivites
    },
    commandes_attentes: state => {
        return state.commandes_attentes
   },
    pecActivites: state => {
        return state.pecActivites
   },

    activitesList: state => {
        return state.activitesList
    },
    pecsList: state => {
        return state.pecsList
    },

    amaActivite: state => {
         return state.amaActivite
     }
 };
 
 // Actions
 const actions = {
     getAmaActivites(context, payload) {
         function successCallback(response) {
             context.commit('getAmaActivitesHandler', { amaActivites: response.data.activites });
            
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.AmaActivite.List, localToken, successCallback, errorCallback, payload.errorMessages);
     },

     getCommandesAttentes(context, payload) {
        function successCallback(response) {
            context.commit('getCommandesAttentesHandler', { commandes_attentes: response.data.commandes});
           
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Commandes_attentes.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
     createTask(context, payload) {
        function successCallback(response) {
            context.commit('createTaskHandler', { amaActivite: response.data.activite });
            Vue.swal(
                'Activité AMA ajouté avec succès',
                '',
                'success'
            );
           
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.AmaActivite.CreateTask, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    createPec(context, payload) {
        function successCallback(response) {
            context.commit('createPecHandler', { pecActivites: response.data.activite });
           
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.PecActivite.CreatePec, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    // getPec(context, payload) {
    //     function successCallback(response) {
    //         context.commit('getPecHandler', { pecActivite: response.data.activite });
           
    //     }

    //     function errorCallback(error) {
    //         Vue.swal(
    //             payload.errorMessages.error,
    //             '',
    //             'error'
    //         );
    //     }

    //     const localToken = localStorage.getItem('ms-token');

    //     makeApiRequest(payload.args, apiModel.PecActivite.ListPec, localToken, successCallback, errorCallback, payload.errorMessages);
    // },
    getPecActivites(context, payload) {
        function successCallback(response) {
            context.commit('getPecActivitesHandler', { PecActivite: response.data.activites });
           
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.PecActivite.ListPec, localToken, successCallback, errorCallback, payload.errorMessages);
    },

     saveSections(context, payload) {
        function successCallback(response) {
            context.commit('saveSectionsHandler', { amaActivites: response.data.activites });
           
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.AmaActivite.Save, localToken, successCallback, errorCallback, payload.errorMessages);
    },
     getamaActivite(context, payload) {
         function successCallback(response) {
             context.commit('getamaActiviteHandler', { antecedent: response.data.antecedent });
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.amaActivite.Get, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     createAmaActivite(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.AmaActivite.Create, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
 };
 
 // Mutations
 const mutations = {
     getAmaActivitesHandler(state, { amaActivites }) {
        let toDo = [];
        let enCours = [];
        let termine = [];
        let gArray = [];

        _.forEach(amaActivites,function(item){  
                    if(item.statut==="En cours"){
                        enCours.push(item);
                    }else if(item.statut==="Terminé"){
                        termine.push(item);
                    }else {
                        toDo.push(item);
                    }
        });

        gArray.push({id: 1, title: 'toDo',tasks: toDo});
        gArray.push({id: 2, title: 'doing',tasks: enCours});
        gArray.push({id: 3, title: 'cloture',tasks: termine});
        state.amaActivites = gArray;
        state.activitesList = amaActivites;
        state.pecActivites = pecActivites;
     },
 
     getAmaActiviteHandler(state, { amaActivite }) {
         // Update amaActivite state
         state.amaActivite = amaActivite;
     },
     getCommandesAttentesHandler(state, { commandes_attentes}) {
        // Update commandesattentes state
        state.commandes_attentes = commandes_attentes;
    },
     getPecActivitesHandler(state, { pecActivites }) {
        // Update amaActivite state
        state.pecActivites = pecActivites;
    },
 
 };
 
 export default {
     state,
     getters,
     actions,
     mutations
 }